/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Charge/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Charge({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/Breakdown/Treatment/Charges/Content/Expandable/Content/Charge"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let chargeNameValueData = fromData.useDataValue({ viewPath,
context: 'charge',
path: 'name',
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let chargeAmountValueData = fromData.useDataFormat({ viewPath,
context: 'charge',
path: 'amount',
format: fromFormat.numberMoney,
})
  return (<React.Fragment
>
<div
  data-testid="Charge.Horizontal"
  data-view-path={viewPath}
 style={{'--pb-1-2nG5Pd': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 color={dtColorsNeutral600}
 data="charge.name"
 text={chargeNameValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 weight="semibold"
 data="charge.amount"
 format="/Data/format.js numberMoney"
 text={chargeAmountValueData}
/>
</div>
{children}
</React.Fragment>)
}